import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { FundingMaType } from "@/enum/funding-ma.enum";

const { REQUIRED } = ERROR_TYPE;

export const FundingMaCompanySchema = z.object({
	id: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	amount: z.number().nullable(),
	currency: z.string().nullable(),
	date: z.string().nullable(),
	investors: z.array(z.object({ name: z.string(), linkedin_url: z.string() })).nullable(),
	round: z.string().nullable(),
	companyInterestedIn: z.array(z.string()).nullable(),
	postUrl: z.string().nullable(),
	percentage: z.string().nullable(),
	acquiredByName: z.string().nullable(),
	acquiredByLinkedinUrl: z.string().nullable(),
});

export const FundingMaCompanyPersonSchema = z.object({
	fundingMaCompany: FundingMaCompanySchema,
});

export const FundingMaSchema = z.object({
	id: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	countries: z.array(z.string()).nullable(),
	category: z.array(z.string()).nullable(),
	round: z.array(z.string()).nullable(),
	lastXDays: z.number().nullable(),
	dateFrom: z.string().nullable(),
	dateTo: z.string().nullable(),
	type: z.nativeEnum(FundingMaType),
});

export const CreateFundingMaSchema = z.object({
	id: z.number().optional(),
	listId: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	countries: z.array(z.string()).nullable(),
	round: z.array(z.string()).nullable(),
	category: z.array(z.string()).nullable(),
	lastXDays: z.number().nullable(),
	dateFrom: z.string().nullable(),
	dateTo: z.string().nullable(),
	type: z.nativeEnum(FundingMaType),
});

export const FundingMaResponseSchema = z.object({
	data: z.array(FundingMaSchema),
	meta: MetaDataSchema,
});

export type FundingMa = z.infer<typeof FundingMaSchema>;
export type FundingMaResponse = z.infer<typeof FundingMaResponseSchema>;

export type CreateFundingMa = z.infer<typeof CreateFundingMaSchema>;
